<div style="display: flex; flex-direction: row; justify-content: space-between">
  <div class="purchase-order-details full-width-container1"
    style="display: flex; flex-direction: column; overflow-x: hidden">
    <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%">
      <mat-card class="p-0" style="margin: 0 0.5rem">
        <mat-card-content #pdfContent class="ship-fscoll hgt ship-pr-sec">
          <div class="purchase-order-details-title">

            <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin: 10px 0;
                ">
              <div id="purchaseOrderDetails" style="font-size: 26px; font-weight: 949">
                Dispatch Form
                <h3>Fill dispatch details, upload documents, and track multi-stage shipments</h3>
              </div>

              <!-- Action Buttons -->
              <!-- <div style="display: flex; gap: 10px">
                  <button
                    mat-stroked-button
                    color="primary"
                    style="
                      font-size: 18px;
                      padding-left: 32px;
                      padding-right: 32px;
                      padding-top: 24px;
                      padding-bottom: 24px;
                      color: #42a190;
                      background-color: #d9e0e4;
                    "
                    (click)="uploadPOD()"
                  >
                    Upload POD
                    <mat-icon style="color: #42a190">upload</mat-icon>
                  </button>
  
                  <button
                    mat-stroked-button
                    color="primary"
                    style="
                      font-size: 18px;
                      padding-left: 32px;
                      padding-right: 32px;
                      padding-top: 24px;
                      padding-bottom: 24px;
                      color: #42a190;
                      background-color: #d9e0e4;
                    "
                    [matMenuTriggerFor]="downloadMenu"
                  >
                    Packaging Documents
                    <mat-icon style="color: #42a190">arrow_drop_down</mat-icon>
                  </button>
  
                  <mat-menu #downloadMenu="matMenu">
                    <button
                      mat-menu-item
                      (click)="onSelectDownload('Commercial Invoice')"
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Commercial Invoice</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="onSelectDownload('Packaging List')"
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Packing Slip</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="onSelectDownload('Delivery Note')"
                    >
                      <mat-icon>download</mat-icon>
                      <span>Download Delivery Note</span>
                    </button>
                  </mat-menu>
                </div> -->
            </div>
          </div>

          <div style="width: 100%">
            <form [formGroup]="dispatchFormGroup">
              <div>
                <!-- Order Details -->
                <div class="header-form-header">
                  <span style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      " (click)="toggleVisibility('form1')">
                    <div style="display: flex; align-items: center;">
                      Order Details

                      <button mat-icon-button matSuffix type="button" matTooltipClass="mat-tooltip-custom" matTooltipPosition="left"
                      [matTooltip]="orderDetailsTooltip">
                      <mat-icon>info_outline</mat-icon>
                      </button>
                    </div>
                    <mat-icon>{{
                      isForm1Expand ? "minimize" : "add"
                      }}</mat-icon>
                  </span>

                  <div *ngIf="isForm1Expand" class="three-column-flex">
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>RFQ Ref No</mat-label>
                        <input matInput formControlName="rfqRefNumber" readonly />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Quote Ref No</mat-label>
                        <input matInput formControlName="quoteRefNumber" readonly />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>PO Number</mat-label>
                        <input matInput formControlName="poRefNumber" readonly />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Invoice Number</mat-label>
                        <input matInput formControlName="invoiceRefNumber" readonly />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Supplier Dispatch Ref</mat-label>
                        <input matInput formControlName="supplierDispatchRefNumber" />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Incoterms</mat-label>


                        <mat-select formControlName="incoterms">
                          <mat-option *ngFor="let item of incoterms" [value]="item.id">
                            {{ item.incotermCode }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Dispatch Date</mat-label>

                        <input matInput name="dispatchDate" formControlName="dispatchDate"
                          [matDatepicker]="dispatchDateDatepicker" [min]="minDate" />

                        <mat-datepicker-toggle matSuffix [for]="dispatchDateDatepicker"
                          [disabled]="false"></mat-datepicker-toggle>

                        <mat-datepicker #dispatchDateDatepicker></mat-datepicker>

                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Freight Details -->
                <div class="header-form-header">
                  <span style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      " (click)="toggleVisibility('form2')">
                    
                    <div style="display: flex; align-items: center;">
                      Freight Forwarder Details
                      <button mat-icon-button matSuffix type="button" matTooltipClass="mat-tooltip-custom" matTooltipPosition="left"
                      [matTooltip]="freightTooltip">
                      <mat-icon>info_outline</mat-icon>
                      </button>
                    </div>
                    <mat-icon>{{
                      isForm2Expand ? "minimize" : "add"
                      }}</mat-icon>
                  </span>

                  <div *ngIf="isForm2Expand" class="three-column-flex">
                    <div class="form-item-row-header">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Freight Forwarder</mat-label>
                        <input matInput formControlName="freightForwarder" readonly />
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header">


                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Mode of Transport</mat-label>
                        <mat-select formControlName="modeOfTransport">
                          <mat-option *ngFor="let transport of availableModes" [value]="transport.id">
                            {{ transport.modeOfTransport }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="form-item-row-header" style="height: auto;flex-direction: column;">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>AWB Number</mat-label>
                        <input matInput formControlName="awbNumber" 
                        maxlength="12"
                        placeholder="XXX-YYYYYYYY" 
                        inputmode="numeric"
                        pattern="[0-9-]*"
                        oninput="this.value = this.value.replace(/[^0-9-]/g, '')"/>
                      </mat-form-field>

                      <mat-error *ngIf="dispatchFormGroup.get('awbNumber')?.hasError('pattern')">
                        Invalid AWB format. Expected XXX-YYYYYYYY
                      </mat-error>
                    </div>

                    <div class="form-item-row-header" style="height: auto;flex-direction: column;">
                      <mat-form-field class="full-width" color="accent">
                        <mat-label>Tracking Link</mat-label>
                        <input matInput formControlName="trackingLink"  />
                      </mat-form-field>
                      <mat-error *ngIf="dispatchFormGroup.get('trackingLink')?.hasError('pattern')">
                        Please enter a valid URL starting with http:// or https://
                      </mat-error>
                    </div>


                  </div>
                </div>

                <div style="margin-top: 30px;display: flex;justify-self: end;">
                  <button mat-icon-button matSuffix type="button" matTooltipClass="mat-tooltip-custom" matTooltipPosition="left"
                  [matTooltip]="createDeliveryRequirementTooltip">
                  <mat-icon>info_outline</mat-icon>
                   </button>

                  <button class="right-button" 
                  (click)="toggleSidebar(true,'requirementForm')">Create new Requirement
                  </button>
                </div>
              
                <mat-accordion class="custom-accordion">
                  <!-- Loop through distinct requirement types -->
                  <mat-expansion-panel *ngFor="let type of requirementTypes">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ type | titlecase }} Requirements
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <!-- Loop through requirements under this type -->
                    <div *ngFor="let req of getRequirementsByType(type)" style="padding: 20px;">
                      <div class="alert alert-info d-flex align-items-center justify-content-between" role="alert"
                        style="border-radius: 8px;">
                        <!-- Left: Icon + Heading + Description -->
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3">{{ req.iconName }}</mat-icon>
                          <div>
                            <h6 class="mb-1 fw-bold">{{ req.requirementName }}</h6>
                            <p class="mb-0 small">{{ req.requirementDescription }}</p>
                          </div>
                        </div>

                        <!-- Right: Checkbox -->
                        <mat-checkbox color="primary" class="ms-3"
                        [checked]="isRequirementSelected(req.requirementId)"
                        (change)="onSelectDeselctRequirements($event,req.requirementId)"
                        ></mat-checkbox>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>


                <div class="header-form-header">
                  <span style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      ">
                   
                    <div style="display: flex; align-items: center;">
                      Upload Documents
                      <button mat-icon-button matSuffix type="button" matTooltipClass="mat-tooltip-custom" matTooltipPosition="left"
                      [matTooltip]="documentTooltip">
                      <mat-icon>info_outline</mat-icon>
                      </button>
                    </div>
                  </span>
                  <!-- Document upload -->
                  <div style="padding: 0 16px 16px 16px">
                   
                    <!-- Proof of Pickup Section -->
                    <div class="mt-4">
                      <h3 style="font-weight: bold;">Proof of Pickup  <span style="color: red;"> *</span></h3>
                      <div class="row">
                        <div class="col-md-6 mb-3">
                          <ngx-file-drop class="w100 file-drop-zone" dropZoneLabel="Drop files here"
                            (onFileDrop)="onAttachmentChange($event,'proofOfPickup')" (onFileOver)="fileOver($event)"
                            (onFileLeave)="fileLeave($event)"
                            accept=".png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF">
                            <ng-template style="display: flex; flex-direction: row" ngx-file-drop-content-tmp
                              let-openFileSelector="openFileSelector">
                              <div class="drag-file text-center">
                                <mat-icon>cloud_upload</mat-icon>
                                <p>Drag & drop the file here or</p>
                                <div (click)="openFileSelector()">
                                  <p style="color: #74c5b5">upload a file</p>
                                </div>
                                <p>*PDF, JPG or PNG</p>
                              </div>
                            </ng-template>
                          </ngx-file-drop>
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="file-name-box">
                            {{
                            getProofOfPickupAttachment().length > 1
                            ? getProofOfPickupAttachment().length + " files attached"
                            : getProofOfPickupAttachment().length === 1
                            ? "1 file attached"
                            : "No file attached"
                            }}
                        
                            <button *ngIf="getProofOfPickupAttachment().length > 0 " mat-icon-button matTooltipClass="mat-tooltip-custom"
                              matTooltip="View" matTooltipPosition="below" (click)="togglePreview(true, 'proofOfPickup')">
                              <mat-icon>visibility</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Additional Documents Section -->
                    <div class="mt-5">
                      <h3 style="font-weight: bold;">Additional Documents</h3>
                      <div class="row">
                        <div class="col-md-6 mb-3">
                          <ngx-file-drop class="w100 file-drop-zone" dropZoneLabel="Drop files here"
                            (onFileDrop)="onAttachmentChange($event,'additionalDocument')" (onFileOver)="fileOver($event)"
                            (onFileLeave)="fileLeave($event)"
                            accept=".png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF">
                            <ng-template style="display: flex; flex-direction: row" ngx-file-drop-content-tmp
                              let-openFileSelector="openFileSelector">
                              <div class="drag-file text-center">
                                <mat-icon>cloud_upload</mat-icon>
                                <p>Drag & drop the file here or</p>
                                <div (click)="openFileSelector()">
                                  <p style="color: #74c5b5">upload a file</p>
                                </div>
                                <p>*PDF, JPG or PNG</p>
                              </div>
                            </ng-template>
                          </ngx-file-drop>
                          
                        </div>
                        <div class="col-md-6 mb-3">
                          <div class="file-name-box">
                            {{
                              getAdditionalAttachment().length > 1
                            ? getAdditionalAttachment().length + " files attached"
                            : getAdditionalAttachment().length === 1
                            ? "1 file attached"
                            : "No file attached"
                            }}
                        
                    

                            <button *ngIf="getAdditionalAttachment().length > 0 " mat-icon-button matTooltipClass="mat-tooltip-custom"
                              matTooltip="View" matTooltipPosition="below" (click)="togglePreview(true, 'additionalDocument')">
                              <mat-icon>visibility</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </form>
          </div>

          <div style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 20px;
              ">
            <button mat-raised-button color="warn" (click)="closeCreateDispatchPage()" style="
                  font-size: 18px;
                  padding-left: 32px;
                  padding-right: 32px;
                  padding-top: 24px;
                  padding-bottom: 24px;
                  background-color: #d11;
                  margin-right: 5px;
                ">
              Close
            </button>
            <button
                mat-raised-button
                color="primary"
                (click)="submit()"
                *ngIf="!isSaved"
                style="
                  font-size: 18px;
                  padding-left: 23px;
                  padding-right: 23px;
                  padding-top: 24px;
                  padding-bottom: 24px;
                  background-color: #1f7e3f;
                  margin-left: 5px;
                "
              >
                Submit Dispatch Information
              </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
<!-- Missing Fields Notification Overlay -->
<div *ngIf="showNotification">
  <div class="notification-overlay" (click)="dismissNotification()"></div>
  <div class="notification-popup show" [ngClass]="{
        'info-notification': notificationType === 'info',
        'error-notification': notificationType === 'error'
      }">
    <div class="notification-content">
      <h3 style="margin-top: 0; margin-bottom: 12px">{{ notificationTitle }}</h3>
      <div class="notification-message" [innerHTML]="notificationMessage"></div>
      <button type="button" class="btn-ok" (click)="dismissNotification()">
        OK
      </button>
    </div>
  </div>
</div>


<div class="sidebar" style="overflow: auto" *ngIf="showAddDispatchRequirement">
  <div class="sidebar-title" style="justify-content: space-between; padding: 15px 15px">
    <div class="sidebar-title-text">Add New Requirements</div>
    <div style="
      display: flex;
      justify-content: right;
      width: 50%;
      gap: 10px;
    ">

      <span style="float: right" class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom"
        matTooltip="Close" matTooltipPosition="below" (click)="toggleSidebar(false, 'requirementForm')">
        <mat-icon style="color: white">close</mat-icon>
      </span>
    </div>
  </div>

  <div class="sidebar-content">
    <form [formGroup]="requirementsFormGroup">


      <mat-form-field class="full-width" color="accent">
        <mat-label>Requirement Type</mat-label>
        <mat-select matInput formControlName="requirementType" (selectionChange)="onTypeChange($event)">
          <mat-option *ngFor="let item of typeData" [value]="item.name">
            {{ item.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="requirementsFormGroup.get('requirementType')?.value === 'other'">
        <mat-form-field class="full-width" color="accent">
          <mat-label>Requirement Type</mat-label>
          <input matInput formControlName="typeName" />
        </mat-form-field>
      </ng-container>




      <mat-form-field class="full-width" color="accent">
        <mat-label>Requirement Name</mat-label>
        <input matInput formControlName="requirementName" />
      </mat-form-field>

      <mat-form-field class="full-width" color="accent">
        <mat-label>Requirement Description</mat-label>
        <input matInput formControlName="requirementDescription" />
      </mat-form-field>


    </form>

    <div class="button-container">
      <button type="button" class="save-button" (click)="createDispatchRequirement()">
        <mat-icon>save</mat-icon>
      </button>
      <button type="button" class="close-button" (click)="toggleSidebar(false, 'requirementForm')">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>

  </div>
</div>


<div class="carousel-container" *ngIf="previewSection">
  <div
    class="carousel-close-button"
    style="display: flex; flex-direction: row; gap: 10px"
  >
    <button class="image-download-button" *ngIf="previewDocs.length>0"   (click)="downloadDocFile(previewDocs[currentIndex]?.dataUrl)">
          <mat-icon style="font-size:20px">download</mat-icon>
   </button>

    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon style="font-size: 20px">cancel</mat-icon> 
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(previewDocs[currentIndex]?.dataUrl)"
      >
        <pdf-viewer
          [src]="previewDocs[currentIndex]?.dataUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(previewDocs[currentIndex]?.dataUrl)"
      >
        <img
          [src]="previewDocs[currentIndex]?.dataUrl"
          [alt]="'dispatch-image'"
          class="carousel-image"
        />
      </div>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>